export enum TextColorsEnum {
  APP_PRIMARY = 'primary',
  TEXT_PRIMARY = 'text-primary',
}
